/**
 * File: maApp.error.module.js
 *
 */
(function(){
    angular
        .module('maApp.error', [
            'zeroclipboard',
            'ngDialog'
        ]);
})();